<button
  mat-icon-button
  [matTooltip]="'Delete'"
  [intercomTarget]="'toolbar-context-menu-delete'"
  (click)="deleteClick.emit()"
>
  <fa-icon [icon]="['fal', 'trash-can']" class="text-[14px]"></fa-icon>
</button>
